// Making sure all fields are correct, Apollo throws error in case any field is not present in schema
export const mapItemsToRequestLines = (items) =>
  items.map((item) => ({
    serialNumber: item.serialNumber,
    exceptionDescription: item.exceptionDescription,
    failureCode: item.failureCode,
    serviceActivity: item.serviceActivity,
    failureDescription: item.failureDescription,
    reviewDescription: item.reviewDescription,
    acceptedCharges: item.acceptedCharges,
    reviewRequested: item.reviewRequested,
    status: item.status,
    partSfId: item.partSfId,
    partNumber: item.partNumber,
    partName: item.partName,
    initialPrice: item.initialPrice,
  }));

export const getCreateCaseVariables = ({
  accountId,
  checkout,
  items,
  totalPrice,
  currencyConversionRate,
  currencyCode,
}) => ({
  variables: {
    case: {
      accountId,
      currencyCode,
      caseTotal: totalPrice,
      poNumber: checkout.billing.poNumber,
      shipping: {
        address: checkout.shipping.address,
        method: checkout.shipping.method,
        packingInstructions: checkout.shipping.packingInstructions,
      },
      requestLines: mapItemsToRequestLines(items),
    },
  },
});
